import { StyleSheet, View, type ViewProps } from "react-native";

import { spacing } from "~/styles/theme";
import type { Space } from "./types";

export function Row({
  between = false,
  gap = "sm",
  align = "center",
  justify = "start",
  wrap = false,
  style,
  ...props
}: ViewProps & {
  between?: boolean;
  gap?: Space;
  align?: "stretch" | "start" | "center" | "end";
  justify?: "start" | "center" | "end" | "between";
  wrap?: boolean;
}) {
  return (
    <View
      style={[
        stylesheet.row,
        gapStyles[gap],
        alignStyles[align],
        justifyStyles[between ? "between" : justify],
        wrap ? stylesheet.wrap : null,
        style,
      ]}
      {...props}
    />
  );
}

const stylesheet = StyleSheet.create({
  row: { flexDirection: "row" },
  wrap: { flexWrap: "wrap" },
  gapNone: { gap: 0 },
  gapXs: { gap: spacing.xs },
  gapSm: { gap: spacing.s },
  gapMd: { gap: spacing.m },
  gapLg: { gap: spacing.l },
  gapXl: { gap: spacing.xl },
  gapXxl: { gap: spacing.xxl },
  alignStretch: { alignItems: "stretch" },
  alignStart: { alignItems: "flex-start" },
  alignCenter: { alignItems: "center" },
  alignEnd: { alignItems: "flex-end" },
  justifyStart: { justifyContent: "flex-start" },
  justifyCenter: { justifyContent: "center" },
  justifyEnd: { justifyContent: "flex-end" },
  justifyBetween: { justifyContent: "space-between" },
});

const gapStyles = {
  none: stylesheet.gapNone,
  xs: stylesheet.gapXs,
  sm: stylesheet.gapSm,
  md: stylesheet.gapMd,
  lg: stylesheet.gapLg,
  xl: stylesheet.gapXl,
  xxl: stylesheet.gapXxl,
};

const alignStyles = {
  stretch: stylesheet.alignStretch,
  start: stylesheet.alignStart,
  center: stylesheet.alignCenter,
  end: stylesheet.alignEnd,
};

const justifyStyles = {
  start: stylesheet.justifyStart,
  center: stylesheet.justifyCenter,
  end: stylesheet.justifyEnd,
  between: stylesheet.justifyBetween,
};
